import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69ee3b7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "iframe-mask"
}
const _hoisted_3 = { class: "iframe-mask__content" }

import { computed, PropType, onMounted, ref, onUnmounted, reactive } from 'vue'
import TreeList from '../kdocsTreeList/index.vue'
import { INodeItem } from '@teams/common/hooks/useTreeBase'
import useMitt from '@/hooks/useMitt'
import { events } from '@/constants'
import Loading from '@teams/common/components/loading'
import { useUserStore } from '@/store/user'

type MessageParams = {
  source?: 'wps_team_app'
  type: string
  params: Record<string, unknown>
}


export default /*#__PURE__*/_defineComponent({
  __name: 'KdocsIframe',
  props: {
  url: {
    type: String,
    default: ''
  },
  navParams: {
    type: Object as PropType<{
      companyId: string
      fid?: string
      groupId: string
    }>,
    default: () => ({})
  },
  navId: {
    type: Number
  }
},
  setup(__props) {

const props = __props

const userStore = useUserStore()
const emitter = useMitt()


const iframe = ref<HTMLIFrameElement | null>(null)
const showMark = ref(false)
const iframeLoaded = ref(false)
// tree拖拽宽度存储所需参数
const treeWideStore = reactive({
  nid: props.navId,
  groupId: props.navParams.groupId,
  userId: userStore.userId
})
const treeList = ref<{ pathChange(data): void } | null>(null)
const getEventName = (eventName: string) => `${eventName}_${props.navId}`
const src = computed(() => {
  return props.url
})
// 切换文件夹
const changeDir = (node: INodeItem) => {
  const {
    params: { groupId, fid }
  } = node
  const data: MessageParams = {
    type: 'page',
    params: {
      tid: groupId,
      fid: fid
    }
  }
  if (props.navParams.companyId) {
    data.params.cid = props.navParams.companyId
  }
  postMessage(data)
}
// 进入回收站
const entryTrash = () => {
  const data: MessageParams = {
    type: 'page',
    params: {
      key: 'trash'
    }
  }
  if (props.navParams.companyId) {
    data.params.cid = props.navParams.companyId
  }
  postMessage(data)
}
// 打开搜索
const entrySearch = (node: INodeItem) => {
  const {
    label,
    params: { groupId, fid }
  } = node
  const data: MessageParams = {
    type: 'search',
    params: {
      fname: label,
      tid: groupId,
      fid: fid
    }
  }
  postMessage(data)
}

// 拖动目录
const isDragWide = ref(false)
const startDragEvent = () => {
  isDragWide.value = true
  isBlockIframeEvent.value = true
}
const endDragEvent = () => {
  isDragWide.value = false
  isBlockIframeEvent.value = false
}
// 拖动悬浮球
const isBlockIframeEvent = ref(false)
emitter.on(events.canMove, msg => {
  isBlockIframeEvent.value = msg as boolean
})

const postMessage = (data: MessageParams) => {
  data.source = 'wps_team_app'
  try {
    const iframeWindow = iframe?.value?.contentWindow
    iframeWindow && iframeWindow.postMessage(JSON.stringify(data), '*')
  } catch (e) {
    console.log('postMessage', e)
  }
}

const iframeObservers = ref<Array<MutationObserver>>([])
const watchIframeMarkChange = () => {
  const config = {
    attributes: true, // 检测属性变动
    attributeFilter: ['class'] // 标签所带的属性都可添加，包括自定义属性
  }

  const observer = new MutationObserver(mutations => {
    const eleBody = mutations[0]?.target as HTMLElement
    if (eleBody) {
      showMark.value =
        eleBody.classList.contains('el-popup-parent--hidden') ||
        eleBody.classList.contains('kd-popup-parent--hidden')
    }
  })

  observer.observe((iframe?.value?.contentDocument as Document)?.body, config)
  iframeObservers.value.push(observer)
}

const iframeOnLoad = () => {
  try {
    // iframe加载完成，往iframeWindow挂载当前的导航id
    const iframeWindow = iframe?.value?.contentWindow
    if (iframeWindow) {
      // @ts-ignore
      iframeWindow.__teamApp = {
        navId: props.navId
      }
      watchIframeMarkChange()
    }
  } catch (e) {}
  iframeLoaded.value = true
}

const eventList = [
  {
    event: getEventName(events.kdocsPathChange),
    handler: data => treeList.value?.pathChange(data.params)
  },
  {
    event: getEventName(events.kdocsRefreshMenu),
    handler: data => treeList.value?.refreshMenu(data.params)
  },
  {
    event: getEventName(events.kdocsRemoveMenu),
    handler: data => treeList.value?.removeMenu(data.params)
  },
  {
    event: getEventName(events.kdocsFolderRename),
    handler: data => treeList.value?.rename(data.params)
  }
]

onMounted(() => {
  eventList.forEach(({ event, handler }) => {
    emitter.on(event, handler)
  })
})

const cleanIframeObservers = () => {
  iframeObservers.value.forEach(o => {
    o.disconnect()
  })
  iframeObservers.value = []
}
onUnmounted(() => {
  eventList.forEach(({ event, handler }) => {
    emitter.off(event, handler)
  })
  cleanIframeObservers()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["iframe-wrapper", {
      'tree-wide-draing': isDragWide.value,
      'iframe-wrapper--mark': showMark.value
    }])
  }, [
    _createVNode(TreeList, {
      ref_key: "treeList",
      ref: treeList,
      class: _normalizeClass({ 'tree--mask': showMark.value }),
      treeWideStore: treeWideStore,
      groupId: __props.navParams.groupId,
      fid: __props.navParams.fid,
      onChangeDir: changeDir,
      onEntryTrash: entryTrash,
      onEntrySearch: entrySearch,
      onStartDragEvent: startDragEvent,
      onEndDragEvent: endDragEvent
    }, null, 8, ["class", "treeWideStore", "groupId", "fid"]),
    _withDirectives(_createElementVNode("iframe", {
      src: _unref(src),
      class: "iframe-kdocs__content",
      frameborder: "0",
      ref_key: "iframe",
      ref: iframe,
      onLoad: iframeOnLoad,
      style: _normalizeStyle(isBlockIframeEvent.value ? 'pointer-events: none' : '')
    }, null, 44, _hoisted_1), [
      [_vShow, iframeLoaded.value]
    ]),
    (!iframeLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Loading), { useType: 'pc' })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})